import { Link } from 'react-router-dom';

export default function UseCases() {
  return (
    <section className="relative py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-6xl font-thin mb-4">Infinite Possibilities</h2>
          <p className="text-xl text-gray-400">From Backyard Retreats to Resort Destinations</p>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {/* Large Card - Luxury Glamping */}
          <div className="md:col-span-7 md:row-span-2 group relative h-[600px] rounded-2xl overflow-hidden cursor-pointer">
            <img 
              src="/images/ai-futuristic-space-capsule-pod-cabin-in-up-3ebd91.webp" 
              alt="Luxury Glamping"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-10 space-y-3">
              <h3 className="text-4xl font-medium text-white">Luxury Glamping</h3>
              <p className="text-gray-300 text-lg max-w-md">Create unforgettable guest experiences in distinctive settings</p>
            </div>
            <div className="absolute top-6 right-6 bg-cyan-500/20 backdrop-blur-md border border-cyan-400/50 rounded-full px-4 py-2 text-cyan-400 text-sm font-medium">
              Most Popular
            </div>
          </div>

          {/* Top Right - Investment Property */}
          <div className="md:col-span-5 group relative h-[290px] rounded-2xl overflow-hidden cursor-pointer">
            <img 
              src="/images/ai-modern-space-capsule-pod-as-airbnb-renta-1f7ef7.webp" 
              alt="Hospitality Accommodation"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-8 space-y-2">
              <h3 className="text-3xl font-medium text-white">Hospitality Accommodation</h3>
              <p className="text-gray-300 text-sm">Boutique stays and short-term rental opportunities</p>
            </div>
          </div>

          {/* Bottom Right - Backyard Living */}
          <div className="md:col-span-5 group relative h-[290px] rounded-2xl overflow-hidden cursor-pointer">
            <img 
              src="/images/ai-futuristic-capsule-pod-cabin-as-backyard-6a15b9.webp" 
              alt="Private Retreat"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-8 space-y-2">
              <h3 className="text-3xl font-medium text-white">Private Retreat</h3>
              <p className="text-gray-300 text-sm">Secondary dwelling or backyard studio use — subject to local approvals</p>
            </div>
          </div>
        </div>

        {/* Additional Use Case - Resort */}
        <div className="mt-6 group relative h-[350px] rounded-2xl overflow-hidden cursor-pointer">
          <img 
            src="/images/ai-multiple-futuristic-space-capsule-pods-a-ac785a.webp" 
            alt="Resort Deployment"
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent"></div>
          <div className="absolute left-0 top-1/2 -translate-y-1/2 p-12 space-y-3">
            <h3 className="text-4xl font-medium text-white">Resort Deployment</h3>
            <p className="text-gray-300 text-lg max-w-xl">Scalable accommodation solutions for eco-resorts and boutique destinations</p>
            <Link to="/contact" className="inline-block mt-4 px-6 py-3 bg-cyan-500/20 backdrop-blur-md border border-cyan-400/50 rounded-full text-cyan-400 hover:bg-cyan-500/30 transition-all whitespace-nowrap cursor-pointer">
              Discuss Your Site
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}